import { errorHandler } from "@/services/toastHandler";

const initState = () => ({
  loading: false,
});

export default {
  namespaced: true,
  state: initState(),
  mutations: {
    LOAD: (s, data) => (s.loading = data),
  },

  actions: {
    async createDepositMatchOffer({ commit }, payload) {
      commit("LOAD", true);
      try {
        const res = await this.$api.post("/v1/portal/bonuses", payload);
        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD", false);
      }
    },
  },
};
